import { render, staticRenderFns } from "./CrewInfoCard.vue?vue&type=template&id=4b74caf1&scoped=true&"
import script from "./CrewInfoCard.vue?vue&type=script&lang=ts&"
export * from "./CrewInfoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74caf1",
  null
  
)

export default component.exports